import React, { useState } from 'react';
import { Formik, Form, Field, FieldArray } from 'formik';
import { Grid, Box, Button, Divider, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { pdbannerDispatch } from 'reducers/HomeReducer';
import { useNavigate } from 'react-router-dom';

const AddPopularDestinationForm = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { loading } = useSelector((state) => state.home);
	const handleFormSubmit = (values) => {
		const formData = new FormData();
		formData.append('dimage', values.dimage);
		formData.append('destination', values.destination);
		console.log('values', values);
		dispatch(pdbannerDispatch(formData, navigate));
	};

	return (
		<Formik
			initialValues={{
				dimage: '',
				destination: '',
			}}
			onSubmit={handleFormSubmit}>
			{(formik) => {
				const { errors, setFieldValue } = formik;
				return (
					<Form>
						<Box style={{ padding: 10 }}>
							<Box
								style={{
									boxShadow:
										'rgba(0, 0, 0, 0.06) 0px 3px 3px -2px, rgba(0, 0, 0, 0.04) 0px 3px 4px 0px, rgba(0, 0, 0, 0.04) 0px 1px 8px 0px',
									padding: 30,
									background: 'white',
								}}>
								<h2>Add Popular Destination</h2>
								<Divider style={{ marginTop: 20, marginBottom: 20 }} />
								<Grid
									container
									style={{ padding: 10, alignItems: 'center' }}
									spacing={4}>
									<Grid item xs={12} lg={6}>
										<input
											type='file'
											accept='image/*'
											style={{
												borderColor: errors.dimage ? 'red' : '',
												border: '1px dashed #E61855',
												padding: 62,
												width: '100%',
												borderRadius: 12,
											}}
											name='dimage'
											id='dimage'
											className='form-control'
											onChange={(event) => {
												setFieldValue('dimage', event.currentTarget.files[0]);
											}}
										/>

										{errors.dimage ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors.dimage}
											</span>
										) : null}
										{/* <Box
											mt={1}
											mb={1}
											sx={{
												border: '1px dashed #E61855',
												background: '#FDF5F7',
												borderRadius: 5,
												'& .MuiInput-underline:before': {
													borderBottom: 'none'
												}
											}}
											// className={classes.upload}
											onClick={() => fileInputRef.current.click()}>
											<Box
												display='flex'
												alignItems='center'
												justifyContent='center'
												style={{
													padding: 62
												}}>
												<Box display='flex' justifyContent='space-between'>
													<span
														one
														style={{
															color: 'rgba(0, 50, 91, 0.5)',
															fontWeight: 600
														}}>
														Drag and drop or
													</span>
													<span
														style={{
															color: '#E61855',
															marginLeft: 5
														}}>
														Browse
													</span>
												</Box>
											</Box>
											<input
												ref={fileInputRef}
												type='file'
												accept='image/*'
												hidden
												onChange={fileChange}
											/>
										</Box> */}
									</Grid>
									<Grid item xs={12} lg={6}>
										<Field
											name='destination'
											type='text'
											placeHolder='Destination'
											style={{
												padding: 10,
												width: '100%',
												borderRadius: 5,
												border: errors?.destination
													? '2px solid red'
													: '1px solid',
												marginTop: 10,
											}}
											inputProps={{
												style: { padding: 12 },
											}}
										/>
										<br />
										{errors?.destination ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors?.destination}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12} lg={3}>
										{loading ? (
											<CircularProgress />
										) : (
											<Button
												type='submit'
												style={{
													background: 'rgb(25, 118, 210)',
													color: 'white',
													marginTop: 30,
													// padding: 16,
													borderRadius: 5,
													width: '100%',
												}}>
												Upload
											</Button>
										)}
									</Grid>
								</Grid>
							</Box>
						</Box>
					</Form>
				);
			}}
		</Formik>
	);
};

export default AddPopularDestinationForm;
